import { useCallback } from 'react';
import { usePanels } from '../panels/usePanels';
import { aiAgentCenterPanelType } from '../dashboard/aiAgents/aiAgentCenterPanelType';
import { MaybeClosePanelParams } from '../panels/types';

export const useCloseAgentsPanel = () => {
  const { maybeCloseSpecificPanel, isPanelOpen } = usePanels();

  return useCallback((params?: MaybeClosePanelParams) => {
    if (isPanelOpen(aiAgentCenterPanelType)) {
      maybeCloseSpecificPanel(aiAgentCenterPanelType, undefined, params);
    }
  }, [isPanelOpen, maybeCloseSpecificPanel]);
};
